import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { DealerForOpportunityProductReqModel, IOpportunityAnalyticProductModel } from '../models/excelModels'

export class OpportunityAnalyticsForExcelApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/GA4Reporting/DealerForOpportunityProducts',
      requesterInfo,
    })
  }

  public async dealerForOpportunityProducts(
    request: DealerForOpportunityProductReqModel
  ): Promise<IOpportunityAnalyticProductModel[]> {
    return await this.postAsync<IOpportunityAnalyticProductModel[]>(request)
  }
}
